import { ActivatedRoute } from '@angular/router';

import { Component, OnInit, AfterViewInit, ElementRef, ViewChild } from '@angular/core';

@Component({
  selector: 'app-sobre',
  templateUrl: './sobre.component.html',
  styleUrls: ['./sobre.component.scss'],
})
export class SobreComponent implements OnInit, AfterViewInit {
  sobre: any;

  @ViewChild('expediente') element: ElementRef;

  constructor(private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.sobre = this.route.snapshot.data.sobre.expediente;
  }

  ngAfterViewInit() {
    const subtitles = this.element.nativeElement.querySelectorAll('.display');
    subtitles.forEach((el: any) => {
      el.addEventListener('click', () => el.classList.toggle('open'));
    });
  }
}
